import { Component, inject, OnInit } from '@angular/core';
import { trigger, style, animate, transition, query, stagger } from '@angular/animations';
import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderManagementService } from '../../../Services/order-management.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
        
enum REQUESTOR_STATUS  {
  REVIEW_FOR_APPROVAL = 101,
  ORDER_PLACD = 102,
  ORDER_ACCEPTED_BY_DUMPSTER = 103,
  DUMPSTER_HEADING_T0_LOCATION = 104,
  CONTAINER_DELIVERED_INITIATE_PICKUP_REQUEST = 105,
  PENDING_PICKUP_REQUEST = 106,
  PICKUP_CONFIRMED = 107,
  WASTE_COLLECTOIN_IN_PROGRESS = 108,
  FINAL_TRIP_CONFIRMATION_PENDING = 109,
  TRIPS_COMPLETED  = 110,
  CONSTRUCTION_WASTE_DISPOSED_AND_PAYMENT_PENDING = 111,
  PAYMENT_PENDING = 112,
  BALANCE_SAR_CREDITED = 113,
  ORDER_CANCELLED = 114,
}

enum USER_TYPE {
  INDIVIDUAL_REQUESTER = "Individual Requester",
  DUMPSTER = "Dumpster",
  DUMP_YARD = "Dump Yard"
}

@Component({
  selector: 'app-view-timeline',
  standalone: true,
  imports: [CommonModule, RouterModule,NgbTooltipModule],
  templateUrl: './view-timeline.component.html',
  styleUrls: ['./view-timeline.component.css'],
  animations: [
    trigger('timelineAnimation', [
      transition(':enter', [
        query(
          '.timeline-item',
          [
            style({ opacity: 0, transform: 'translateX(-20px)' }),
            stagger(50, [
              animate('0.5s ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
            ])
          ],
          { optional: true }
        )
      ])
    ])
  ]
})
export class ViewTimelineComponent implements OnInit {
  isFirstLoad = true; // Flag to check if it's the first load 

  userTypeDetailsOrder:any[] = []

  individualRequestorStatusCodes = [
    { statusCode: 101, icon: 'fas fa-cart-arrow-down' },
    { statusCode: 102, icon: 'fas fa-check-circle' },
    { statusCode: 103, icon: 'fas fa-truck' },
    { statusCode: 104, icon: 'fas fa-dumpster' },
    { statusCode: 105, icon: 'fas fa-hand-paper' },
    { statusCode: 106, icon: 'fas fa-hourglass-half' },
    { statusCode: 107, icon: 'fas fa-check-circle' },
    { statusCode: 108, icon: 'fas fa-recycle' },
    { statusCode: 109, icon: 'fas fa-clock' },
    { statusCode: 110, icon: 'fas fa-road' },
    { statusCode: 111, icon: 'fas fa-dumpster-fire' },
    { statusCode: 112, icon: 'fas fa-money-bill-wave' },
    { statusCode: 113, icon: 'fas fa-wallet' },
    { statusCode: 114, icon: 'fas fa-times-circle' }
  ]

  dumpsterStatusCodes = [
    { statusCode: 115, icon: 'fas fa-clipboard-check' },
    { statusCode: 116, icon: 'fas fa-route' },
    { statusCode: 117, icon: 'fas fa-map-marker-alt' },
    { statusCode: 118, icon: 'fas fa-dumpster' },
    { statusCode: 119, icon: 'fas fa-hand-paper' },
    { statusCode: 120, icon: 'fas fa-check-circle' },
    { statusCode: 121, icon: 'fas fa-truck'  },
    { statusCode: 122, icon: 'fas fa-map-marker-alt' },
    { statusCode: 123, icon: 'fas fa-recycle' },
    { statusCode: 124, icon: 'fas fa-clock' },
    { statusCode: 125, icon: 'fas fa-check-double' },
    { statusCode: 126, icon: 'fas fa-dumpster' },
    { statusCode: 127, icon: 'fas fa-check-circle' },
    { statusCode: 128, icon: 'fas fa-route' },
    { statusCode: 129, icon: 'fas fa-map-marker-alt' },
    { statusCode: 130, icon: 'fas fa-recycle' },
    { statusCode: 131, icon: 'fas fa-clock' },
    { statusCode: 132, icon: 'fas fa-check-double' },
    { statusCode: 133, icon: 'fas fa-dumpster-fire' },
    { statusCode: 134, icon: 'fas fa-money-bill-wave' },
    { statusCode: 135, icon: 'fas fa-wallet' }
  ]

  dumpyardStatusCodes = [
    { statusCode: 134, icon: 'fas fa-money-bill-wave' },
    { statusCode: 136, icon: 'fas fa-clipboard-check' },
    { statusCode: 137, icon: 'fas fa-route' },
    { statusCode: 138, icon: 'fas fa-recycle' },
    { statusCode: 139, icon: 'fas fa-check-double' },
    { statusCode: 140, icon: 'fas fa-check-circle' },
    { statusCode: 141, icon: 'fas fa-money-bill-wave' },
    { statusCode: 142, icon: 'fas fa-wallet' }
  ]

  constructor(private router: Router, private orderManagementService:OrderManagementService) {}

  private readonly activatedRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    if (this.isFirstLoad) {
      this.isFirstLoad = false; // Only run animation on first load
    }

    this.getOrderTimeLine()
  }

  goBack() {
    this.router.navigate(['/total-request']);
  }

  // Hover logic for changing icon background color
  onStepHover(step: any) {
    if (!step.completed) {
      step.hovered = true;
    }
  }

  onStepHoverExit(step: any) {
    step.hovered = false;
  }

  // Method to get the style for the timeline icon
  getIconStyle(step: any) {
    if (step.completed) {
      return { backgroundColor: '#28a745' };  // Green for completed steps
    } else if (step.hovered) {
      return { backgroundColor: '#ffd700' };  // Gold for hovered steps
    }
    return { backgroundColor: '#007bff' };  // Blue for default and pending steps
  }

  getOrderTimeLine() {
    let orderId:any = ""
    this.activatedRoute.paramMap.subscribe((params) => orderId = params.get('id'))
    this.orderManagementService.getOrderTimeLine(apiEndPoints.orderTimeLineData, orderId).subscribe({
      next:(response:any) => {
        this.userTypeDetailsOrder = response.body.details.userTypeDetailsOrder  

        this.userTypeDetailsOrder.forEach((order) => {      
          if(order.userType == USER_TYPE.INDIVIDUAL_REQUESTER){
            order.statusDetails = this.formatStatusDetails(order.statusDetails, this.individualRequestorStatusCodes)
          }

          if(order.userType == USER_TYPE.DUMPSTER){
            order.statusDetails = this.formatStatusDetails(order.statusDetails, this.dumpsterStatusCodes)
          }

          if(order.userType == USER_TYPE.DUMP_YARD){
            order.statusDetails = this.formatStatusDetails(order.statusDetails, this.dumpyardStatusCodes)
          }
        }) 
      },
      error: (err) => {

      }
    })
  }

  getIcon(userType: string, statusCode:number) {
    let statusCodes:any[] = []
    switch(userType) {
      case USER_TYPE.INDIVIDUAL_REQUESTER:
        statusCodes = this.individualRequestorStatusCodes
        break

      case USER_TYPE.DUMPSTER:
        statusCodes = this.dumpsterStatusCodes
        break

      case USER_TYPE.DUMP_YARD:
        statusCodes = this.dumpyardStatusCodes
        break
    }

    return statusCodes.find((step) => step.id == statusCode)?.icon
  }

  getDateTime(date:string){
    return  date.split(" ")
  }

  formatStatusDetails(statusDetails:any[], statusCodes:any[]) {
    statusDetails.forEach((statusDetail: any) => {
      if(statusDetail.statusCode) {
        let statusIcon: any = statusCodes.find((code) => code.statusCode == statusDetail.statusCode)  
        let [updatedDate, updatedTime] = this.getDateTime(statusDetail.updatedDateTime)

        if(statusIcon) {
          statusDetail.statusIcon = statusIcon.icon
        }else {
          statusDetail.statusIcon = ""
        }

        if(updatedDate) {
          statusDetail.updatedDate = updatedDate
        } else {
          statusDetail.updatedDate = ""
        }

        if(updatedTime) {
          statusDetail.updatedTime = this.convertTime(updatedTime)
        } else {
          statusDetail.updatedTime = ""
        }
      }
    })

    return statusDetails.filter((statusDetail: any) => statusDetail.statusDescription && statusDetail.statusCode)
  }

  convertTime(time:string) {
    let [hour, seconds] = time.split(":")
    let formattedHour = Number(hour)  

    if(formattedHour > 12) {
      return (formattedHour - 12) + ":" + seconds + " PM"
    }else {
      return formattedHour + ":" + seconds + " AM"
    }
  }  
}
